<template>
	<td class="table-complex-cell" >
		
		
			<ux-menu v-model="menuOpen">
                        <template #activator="{ on }">
                        	<ux-button size="sm" @click.stop.prevent v-on="on" icon>
                        		{{value}}
                        	</ux-button>
                        </template>
                        <div class="items">

                        	<ux-pill tag="a" :value="item" @click.stop.prevent="clicked(item)" v-for="item in items"/>
                        </div>
                        <!-- <ux-list>
                            <ux-list-item @click="duplicateField()">
                                Duplicate Field
                            </ux-list-item>
                            <template v-if="canHaveChildren">
                                <ux-list-item @click="addFieldInside()">
                                    Add Field Inside
                                </ux-list-item>
                            </template>
                            <ux-list-item @click="addFieldAfter()">
                                Add Field After
                            </ux-list-item>
                            <ux-list-item @click="deleteField()">
                                Delete Field
                            </ux-list-item>
                        </ux-list> -->
                    </ux-menu>


		
		


		

    </td>
</template>
<script>

import TableCellMixin from './TableCellMixin.js';
import _get  from 'lodash/get';


const stub = '.total';

export default {
	mixins:[TableCellMixin],
	methods:{
		clicked(item) {
			this.menuOpen = false;
			this.$sdk.dispatch('item:view', item);
		},
	},
	data() {
		return {
			menuOpen:false,
		}
	},
	computed:{
		path() {
			return this.column.key || '';
		},
		rawPath() {
			return this.path.slice(0,-stub.length);
		},
		itemPath() {
			return `${this.rawPath}.items`;
		},
		value() {
			return _get(this.row, this.column.key);
		},
		items() {
			return _get(this.row, this.itemPath);
		}

	},
}
</script>


<style scoped lang="scss">

td {
}

.value-circle {
	display: inline-block;
	width:20px;
	height: 20px;
	border-radius: 100%;
	text-align: center;
	line-height: 20px;
	background: rgba(#000, 0.1);
}

.items {
	border-radius: 0.3em;
	overflow: hidden;
	padding:1em;
	background: var(--bg1, #fff);
}


</style>